import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import React, { Fragment, useMemo, useState } from "react";
import { DateFormatTo_YYYY_MM_DD, CSTDateFormatterWithTime_12_hr } from "../../utils/DateFormatter";
import { Button, FormControl, MenuItem, Select, Switch, Typography } from "@mui/material";
import { useErrorLogData } from "../../hooks/useErrorLogData";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import classes from "../Workbench/Workbench.module.css";
import dayjs from "dayjs";
import Loader from "../UI/Loader";
import WithConditional from "../hoc/WithConditional";
import CustomizedSnackbars from "../UI/SnackBar";
import { getToken } from "../../authfile";

const SystemError = () => {

  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [startDate, setStartDate] = useState(dayjs().subtract(15, 'day'));
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [ranges, setRanges] = useState(15);
  const [selectionType, setSelectionType] = useState("days");
  const differenceInDays = endDate.diff(startDate, 'day');
  const formattedDateStart = startDate ? DateFormatTo_YYYY_MM_DD(startDate) : '';
  const formattedDateEnd = endDate ? DateFormatTo_YYYY_MM_DD(endDate) : '';
  const { system_errors, isFetching, isError: isErrorLogData, error: errorLogDataError, refetch } = useErrorLogData({body: {
    fileDate: "",
    fromDate: formattedDateStart,
    toDate: formattedDateEnd,
    key: 0
  }, config: tokenConfig});

  

  const columns = useMemo(
    () => [
      {
        accessorKey: 'ID', //access nested data with dot notation
        header: 'ID',
        size: 50,
      },
      {
        accessorKey: 'ApiName', //access nested data with dot notation
        header: 'API NAME',
        size: 150,
      },
      {
        accessorKey: 'TriggerTime', //access nested data with dot notation
        header: 'TRIGGER TIME',
        size: 150,
        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          if (rowA.original.TriggerTime == null || rowA.original.TriggerTime == undefined) {
            return -1;
          }
          if (rowB.original.TriggerTime == null || rowB.original.TriggerTime == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.TriggerTime);
          const secondDate = new Date(rowB.original.TriggerTime);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          if (row.original.TriggerTime === null || row.original.TriggerTime === undefined) {
            return false;
          }
          const rowValue = new Date(row.original.TriggerTime);
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;


          if (!start)
            return true;


          if (startDate)
            startDate.setHours(0, 0, 0, 0);

          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();

        },

        enableColumnFilter: true,
      },
      {
        accessorKey: 'Status', //access nested data with dot notation
        header: 'STATUS',
        size: 150,
      },
      {
        accessorKey: 'Message', //access nested data with dot notation
        header: 'MESSAGE',
        size: 150,
      },
      {
        accessorKey: 'Case', //access nested data with dot notation
        header: 'CASE',
        size: 120,
      },
      {
        accessorKey: 'Report', //access nested data with dot notation
        header: 'REPORT',
        size: 150,
      },
      {
        accessorKey: 'User', //access nested data with dot notation
        header: 'USER',
        size: 150,
      }

    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: system_errors, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    renderTopToolbarCustomActions: () => <Fragment>
      <Typography variant="h7" color="primary" sx={{ fontWeight: 'bold', borderBottom: '1px solid #002277' }}>SYSTEM ERROR STATS</Typography>
    </Fragment>
  });

  const calculateDays = (days) => {
    const start = new Date();
    start.setDate(start.getDate() - days);
    return start;
  }

  const handleSelectionChange = (e) => {
    setSelectionType(e.target.value);
    handleChange({ target: { value: 90 } })
  };


  const handleChange = (event) => {
    const selectedRange = parseInt(event.target.value, 10);
    setRanges(selectedRange);
    setStartDate(calculateDays(selectedRange));
    setEndDate(dayjs(new Date()));
  }

  return (
    <Fragment>
      <WithConditional when={isFetching}>
        <Loader />
      </WithConditional>
      <WithConditional when={isErrorLogData}>
      <CustomizedSnackbars type="error" API="System Error Logs API" message={errorLogDataError?.message} />
    </WithConditional>
      <div className={classes.rowFilters} >
        <div className={classes.dayFilterRight}>
          <FormControl sx={{ mx: 1 }}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectionType}
              onChange={handleSelectionChange}
              sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
            >
              <MenuItem value="days">Days</MenuItem>
              <MenuItem value="date">Date</MenuItem>
            </Select>
          </FormControl>
          {selectionType === "days" ? (
            <FormControl sx={{ mx: 1 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={ranges}
                onChange={handleChange}
                sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
              >
                <MenuItem value={7}>Last 7 Days</MenuItem>
                <MenuItem value={15}>Last 15 Days</MenuItem>
                <MenuItem value={30}>Last 30 Days</MenuItem>
                <MenuItem value={45}>Last 45 Days</MenuItem>
                <MenuItem value={90}>Last 90 Days</MenuItem>
              </Select>
            </FormControl>


          ) : (
            <Fragment>
              <div className={classes.startDate}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="Start Date"
                    // value={startDate}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                        padding: '8px 14px !important',
                      },

                      '& .MuiInputLabel-root': {
                        marginTop: '-3% !important',
                      }

                    }}
                    onChange={(newValue) => setStartDate(newValue)}
                    format="MM-DD-YYYY"
                  />
                </LocalizationProvider>
              </div>
              <div className={classes.endDate}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="End date"
                    // value={endDate}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                        padding: '8px 14px !important',
                      },
                      '& .MuiInputLabel-root': {
                        marginTop: '-3% !important',
                      }

                    }}
                    onChange={(newValue) => setEndDate(newValue)}
                    format="MM-DD-YYYY"
                  />
                </LocalizationProvider>
              </div>
            </Fragment>
          )}
          <Button variant='contained' sx={{ mx: 1, backgroundColor: '#002677', padding: '0.5rem' }} onClick={() => { refetch() }} className="getResults" >Get Results</Button>
        </div>
      </div>
      <MaterialReactTable table={table} />
    </Fragment>
  )
}

export default SystemError;